import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import JapanRecruitment from "../../components/JapanRecruitment";

const JapanRecruitmentPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={"Japan Recruitment"} pagesub={"About"} />
      <JapanRecruitment />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default JapanRecruitmentPage;
